const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  progressContainer: {
    padding: '40px',
    backgroundColor: '#F8FAFC',
    borderRadius: '20px',
    border: '1px solid #E2E8F0',
    textAlign: 'center',
  },
  progressBar: {
    height: '12px',
    borderRadius: '6px',
    backgroundColor: '#E2E8F0',
    '& .MuiLinearProgress-bar': {
      borderRadius: '6px',
      backgroundColor: '#3B82F6',
    },
  },
  courseProgressGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '16px',
    marginTop: '32px',
    textAlign: 'left',
  },
  courseProgressCard: {
    padding: '16px',
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    border: '1px solid #F1F5F9',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  resultContainer: {
    maxWidth: '600px',
    margin: '0 auto',
    width: '100%',
  },
  resultCard: {
    padding: '48px 32px',
    backgroundColor: '#FFFFFF',
    borderRadius: '24px',
    border: '1px solid #E2E8F0',
    textAlign: 'center',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.04)',
  },
  linkCard: {
    padding: '20px',
    backgroundColor: '#F8FAFC',
    borderRadius: '16px',
    border: '1px solid #E2E8F0',
    textAlign: 'left',
    marginTop: '16px',
    width: '100%',
  },
  linkLabel: {
    fontSize: '12px',
    fontWeight: 700,
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '12px',
    display: 'block',
  },
  linkContent: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    border: '1px solid #E2E8F0',
    padding: '4px 4px 4px 16px',
    gap: '8px',
  },
  linkUrl: {
    fontSize: '14px',
    color: '#1E293B',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },
  linkActions: {
    display: 'flex',
    gap: '4px',
  },
  actionIconBtn: {
    padding: '8px',
    color: '#64748B',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#F1F5F9',
      color: '#3B82F6',
    },
  },
  copySuccess: {
    color: '#10B981 !important',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
  },
})

export default styles
